/* eslint-disable quotes */
import React from "react";

import "./../styles/loading.css";

const Loading = () => (
    <div className="loading-container">
        <span className="loading" />
    </div>
);

export default Loading;
